import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import Amount from "@material-ui/icons/AccountBalanceWalletTwoTone";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { appHelpers } from "../../_helpers";
import { Grid, FormControl } from "@material-ui/core";
import Add from "@material-ui/icons/AddBox";
import InlineDatePicker from "../../utils/InlineDatePicker";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  searchButton: {
    backgroundColor: " #66bb6a",
  },
  airlineSelect: {
    marginTop: "0px",
  },
});

const SettingsPanel = ({
  classes,
  currentPsc,
  startDateNew,
  handleChange,
  handleDateChange,
  handlePsc,
  openModal,
  handleClose,
  fullScreen,
  handlePscSave,
  disabled,
}) => {
  return (
    <div className={classes.root}>
      <form className={classes.container} noValidate>
        <Grid container spacing={24}>
          <Grid item md={4} xs={12}>
            <Card>
              <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <Amount />
                </CardIcon>
                <div style={{ color: "#212121" }}>
                  <p className={classes.cardCategory}>Current PSC Value</p>
                  <h3 className={classes.cardTitle}>
                    &#8358;{" "}
                    {typeof currentPsc === "number"
                      ? appHelpers.numberWithCommas(currentPsc)
                      : currentPsc}
                  </h3>
                </div>
              </CardHeader>
            </Card>
          </Grid>
          <Grid item md={6} xs={12}>
            <Button
              className={classes.searchButton}
              onClick={handlePsc}
              style={{ marginTop: "3vw" }}
            >
              <Add /> Set New PSC
            </Button>
          </Grid>
        </Grid>
        <Dialog
          fullScreen={fullScreen}
          open={openModal}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            id="responsive-dialog-title"
            style={{ backgroundColor: "#66bb6a" }}
          >
            <span style={{ color: "white", textTransform: "uppercase" }}>
              {" "}
              Set New PSC Charge
            </span>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                >
                  <CustomInput
                    required
                    labelText="New PSC Charges (NGN)"
                    id="pscChargesNew"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      name: "pscChargesNew",
                      type: "number",
                      onChange: handleChange,
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                  <FormControl
                    fullWidth
                  >
                    <InlineDatePicker
                      Date={startDateNew}
                      handleDateChange={(date) =>
                        handleDateChange(date, "startDateNew")
                      }
                      label="Start Date"
                      minDate={Date()}
                    />
                  </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={disabled}
              onClick={handlePscSave}
              style={{ backgroundColor: "#66bb6a" }}
              autoFocus
            >
              Set
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </div>
  );
};

export default withStyles(styles)(SettingsPanel);



// WEBPACK FOOTER //
// ./src/views/PscSettings/settingsPanel.js